module.exports = __webpack_public_path__ + "static/media/008_intel5_2.f48a300d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/mashery/008_intel5_2.png
// module id = 554
// module chunks = 0